import Vue from 'vue';

export const timeSheetDetailsService = {
  async retrieveTimeSheet(referenceNumber) {
    return Vue.axios.get(`/time-sheets/${referenceNumber}`).then(response => response.data);
  },

  async retrieveTimeSheetHistory(referenceNumber) {
    return Vue.axios.get(`/time-sheets/${referenceNumber}/history`).then(response => response.data);
  },

  async saveTimeSheetEntries(
    referenceNumber,
    replacedEndClient,
    action,
    approverComment,
    entries,
    notes
  ) {
    return Vue.axios.post(`/time-sheets/${referenceNumber}`, {
      action,
      approverComment,
      entries,
      notes,
      replacedEndClient
    });
  },

  async approveRejectReopenTimeSheet(referenceNumber, action, approverComment) {
    return Vue.axios.post(`/time-sheets/${referenceNumber}`, { action, approverComment });
  },

  async downloadTimeSheetPdf(referenceNumber) {
    const response = await Vue.axios({
      url: `/time-sheets/${referenceNumber}/pdf`,
      method: 'GET',
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Time-Sheet-${referenceNumber}.pdf`);
    document.body.appendChild(link);
    link.click();
  }
};
